"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RangeFieldArray;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function RangeFieldArray(_ref) {
  var field = _ref.field,
    form = _ref.form;
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
    name: "".concat(field.name, ".ranges")
  }, function (arr) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, field.value.ranges && field.value.ranges.length > 0 && field.value.ranges.map(function (range, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "".concat(field.name, ".ranges[").concat(index, "][0]")
      }, "Boundary ", index + 1, ' ', "".concat(index === field.value.ranges.length - 1 ? '(max value)' : '')), /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        style: {
          display: 'flex',
          gap: '1em',
          marginTop: 0,
          marginBottom: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(field.name, ".ranges[").concat(index, "][0]")
      }, function (_ref2) {
        var thisField = _ref2.field;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "number",
          className: "form-control",
          placeholder: "Enter a range",
          disabled: index === field.value.ranges.length - 1,
          min: field.value.ranges && index - 1 !== -1 ? field.value.ranges[index - 1][0] || 0 : 0,
          max: field.value.ranges && index + 1 !== field.value.ranges.length ? field.value.ranges[index + 1][0] || field.value.ranges[field.value.ranges.length - 1][0] : 0
        }, thisField)));
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(field.name, ".ranges[").concat(index, "][1]")
      }, function (_ref3) {
        var thisField = _ref3.field;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "btn-group"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          style: {
            backgroundColor: field.value.ranges[index][1]
          },
          type: "button",
          className: "btn btn-default dropdown-toggle",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "caret"
        })), /*#__PURE__*/_react["default"].createElement("ul", {
          className: "dropdown-menu dropdown-menu-right",
          style: {
            width: '4em'
          }
        }, /*#__PURE__*/_react["default"].createElement("li", {
          onClick: function onClick() {
            return form.setFieldValue("".concat(field.name, ".ranges[").concat(index, "][1]"), '#337ab7');
          },
          style: {
            padding: '0.5em 1em'
          }
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "form-control",
          style: {
            backgroundColor: '#337ab7'
          }
        })), /*#__PURE__*/_react["default"].createElement("li", {
          onClick: function onClick() {
            return form.setFieldValue("".concat(field.name, ".ranges[").concat(index, "][1]"), '#d9534f');
          },
          style: {
            padding: '0.5em 1em'
          }
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "form-control",
          style: {
            backgroundColor: '#d9534f'
          }
        })), /*#__PURE__*/_react["default"].createElement("li", {
          onClick: function onClick() {
            return form.setFieldValue("".concat(field.name, ".ranges[").concat(index, "][1]"), '#f0ad4e');
          },
          style: {
            padding: '0.5em 1em'
          }
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "form-control",
          style: {
            backgroundColor: '#f0ad4e'
          }
        })), /*#__PURE__*/_react["default"].createElement("li", {
          onClick: function onClick() {
            return form.setFieldValue("".concat(field.name, ".ranges[").concat(index, "][1]"), '#5cb85c');
          },
          style: {
            padding: '0.5em 1em'
          }
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "form-control",
          style: {
            backgroundColor: '#5cb85c'
          }
        })), /*#__PURE__*/_react["default"].createElement("li", {
          style: {
            padding: '0.5em 1em'
          }
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "color"
        }, thisField, {
          className: "form-control"
        })))));
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-danger",
        type: "button",
        onClick: function onClick() {
          return arr.remove(index);
        },
        disabled: index === field.value.ranges.length - 1
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))));
    }), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info",
      onClick: function onClick() {
        return arr.insert(field.value.ranges.length - 1, [field.value.ranges[field.value.ranges.length - 1][0] || 0, '#dddddd']);
      },
      style: {
        marginTop: '0.5em'
      }
    }, "Add Range Boundary"));
  });
}